import { theme } from '../constants/defaults';

export default () => `
    <div class="loading-spinner">
      <span class="vh">${theme.strings.loading}</span>
      <span class="loading-spinner__icon">
      </span>
    </div>
  `;
